import { useState } from 'react'

// A small share button: the device's share sheet where there is one,
// otherwise the link goes to the clipboard.
export default function ShareButton({ url, text, label = 'Share link', className = 'pt-share' }) {
    const [copied, setCopied] = useState(false)
    const share = async () => {
        if (navigator.share) {
            try { await navigator.share({ title: 'Hog of War', text, url }); return } catch { /* dismissed: fall through to copy */ }
        }
        try {
            await navigator.clipboard.writeText(url)
            setCopied(true)
            setTimeout(() => setCopied(false), 1500)
        } catch { /* nothing to do: the code is on screen */ }
    }
    return (
        <button type="button" className={className} onClick={share} aria-label={label}>
            {copied ? 'Link copied' : label}
        </button>
    )
}
